<div id="fullscreen" class="btn-header transparent pull-right m-0">
        <div class="svg-icon" (click)="onToggle()"></div>
</div>